module.exports = __webpack_public_path__ + "static/media/svg-2.a4639ea9.svg";